<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">{{ routeName }}</a>
        <button
          class="navbar-toggler navbar-burger"
          type="button"
          @click="toggleSidebar"
          :aria-expanded="$sidebar.showSidebar"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-bar"></span>
          <span class="navbar-toggler-bar"></span>
          <span class="navbar-toggler-bar"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end">
          <ul class="navbar-nav ml-auto navbar__clientPart mr-6">
            <NotificationDropDown></NotificationDropDown>
            <li class="nav-item">Welcome, {{ user.first_name }} {{ user.last_name }}</li>
          </ul>

          <ul class="navbar-nav navbar__clientPart">
            <li class="nav-item" @click="openOrCloseUserInfoModal()">
              <img
                v-if="user.avatar"
                :src="user.avatar"
                class="nav-item__userProfile nav-item__userProfile-img"
                alt=""
              />
              <i v-else class="fas fa-user-circle nav-item__userProfile nav-item__userProfile-icon"></i>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <UserInfoModal :showUserMenu="userMenuModal" @close-user-menu="openOrCloseUserInfoModal()"> </UserInfoModal>
  </div>
</template>
<script>
import UserInfoModal from '../../components/User/UserInfoModal';
import NotificationController from '@/controllers/Notification/NotificationController';
import NotificationDropDown from '@/components/Notifications/NotificationDropDown';
export default {
  components: { NotificationDropDown, UserInfoModal },
  data() {
    return {
      activeNotifications: false,
      userMenuModal: false,
    };
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    openOrCloseUserInfoModal() {
      this.userMenuModal = !this.userMenuModal;
    },
  },
};
</script>
<style>
.dropdown-menu {
  padding-top: 2rem;
}
</style>
